import {styled} from '../../styled-components';

/**
 * Container component for Dialog title at the top of the dialog.
 */
export const DialogTitleStyle = styled.div`
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    height: ${props => props.theme.spacing.units(12)};
    padding: ${props => props.theme.spacing.units(0, 10)};
    background: ${props => props.theme.color.primary.light};
    color: ${props => props.theme.color.white};
    font-size: ${props => props.theme.typography.pxToRem(20)};
    text-transform: uppercase;
    font-family: ${props => props.theme.typography.fontFamily};
    text-align: center;

    @media only screen and (max-width: 760px) {
        font-size: 15px;
        padding: 0;
    }

    @media only screen and (min-width: 1200px) {
        line-height: 30px;
    }
`;

DialogTitleStyle.displayName = 'DialogTitleStyle';
